<template>
  <el-dialog
    :visible="true"
    width="500px"
    @close="$router.replace('/sales/invoice-books')"
    :close-on-click-modal="false"
  >
    <div
      slot="title"
    >
      {{ title }}
    </div>
    <el-tabs
      v-model="activeName"
      v-loading="loading">
      <el-tab-pane
        label="Alapadatok"
        name="1">
        <el-table
          :data="invoiceBookData"
          :show-header="false"
          border
        >
          <el-table-column
            prop="label"
          >
            <template slot-scope="scope">
              <strong>{{ scope.row.label }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.tagType || 'danger'"
                size="small"
                v-if="scope.row.tag"
              >
                {{ scope.row.value }}
              </el-tag>
              <span v-if="!scope.row.tag" style="word-break: normal;">{{ scope.row.value }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="Napló"
        name="2"
      >
        <activity-timeline
          v-if="invoiceBook && invoiceBook.activities"
          :activities="invoiceBook.activities"
          :formatters="activityFormatters"
          :propsMap="propsMap"
        />
      </el-tab-pane>
    </el-tabs>
    <div
      slot="footer"
      class="dialog-footer"
      v-can="['invoicebook.delete', 'invoicebook.update']"
    >
      <el-button
        @click="$router.replace('/sales/invoice-books/update/' + invoiceBook.id)"
        type="primary"
        icon="el-icon-edit"
        v-can="'invoicebook.update'"
      >
        Módosítás
      </el-button>
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteInvoiceBook()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          icon="el-icon-delete"
          type="danger"
          style="margin-left: 5px;"
        >
          Törlés
        </el-button>
      </el-popover>
    </div>
  </el-dialog>
</template>

<script>
  import ActivityTimeline from '../../ActivityTimeline';

  export default {
    components: { ActivityTimeline },
    props: ['invoiceBookId'],
    data() {
      return {
        activeName: '1',
        deleteButtonLoader: false,
        deleteConfirmVisible: false,
        title: 'Betöltés folyamatban...',
        loading: false,
        buttonLoading: false,
        invoiceBook: {},
        invoiceBookData: [],
        activityFormatters: {
          is_real: isReal => ({
            value: isReal ? 'Igen' : 'Nem'
          }),
          is_product_billable: is_product_billable => ({
            value: is_product_billable ? 'Igen' : 'Nem'
          }),
          is_service_billable: is_service_billable => ({
            value: is_service_billable ? 'Igen' : 'Nem'
          }),
          region: region => ({
            value: region === 'abroad' ? 'Külföldi' : 'Belföldi'
          }),
        },
        propsMap: {
          'name': 'Név',
          'prefix': 'Előtag',
          'description': 'Leírás',
          'currency': 'Deviza', //rel
          'gla_number': 'Főkönyvi szám', //rel
          'storage': 'Raktár', //rel
          'invoice_book_template': 'Sablon', //rel
          'own_company': 'Saját cég', //rel
          'is_product_billable': 'Termék számlázandó',
          'is_service_billable': 'Szolgáltatás számlázandó',
          'cash_comment': 'Kp. megjegyzés',
          'transfer_comment': 'Ut. megjegyzés',
          'region': 'Régió',
          'is_real': 'Valódi tömb',
          'default_copies': 'Alapértelmezett példányszám',
        },
      };
    },

    async mounted() {
      await this.fetchData();
    },
    methods: {
      async fetchData() {
        this.loading = true;
        this.invoiceBook = await axios.get(`api/invoice-books/${this.invoiceBookId}`);
        this.title = this.invoiceBook.name;
        this.invoiceBookData = [
          {
            label: 'Id',
            value: this.invoiceBook.id
          },
          {
            label: 'Név',
            value: this.invoiceBook.name
          },
          {
            label: 'Előtag',
            value: this.invoiceBook.prefix ? this.invoiceBook.prefix :  ''
          },
          {
            label: 'Sablon',
            value: this.invoiceBook.invoice_book_template && this.invoiceBook.invoice_book_template.name
          },
          {
            label: 'Valódi tömb',
            value: this.invoiceBook.is_real ? 'Igen' : 'Nem'
          },
          {
            label: 'Deviza',
            value: this.invoiceBook.currency && this.invoiceBook.currency.name
          },
          {
            label: 'Főkönyvi szám',
            value: this.invoiceBook.gla_number && `${this.invoiceBook.gla_number.value}${this.invoiceBook.gla_number.description ? ' - ' + this.invoiceBook.gla_number.description : ''}`,
          },
          {
            label: 'Raktár',
            value: this.invoiceBook.storage &&  this.invoiceBook.storage.name
          },
          {
            label: 'Saját cég',
            value: this.invoiceBook.own_company &&  this.invoiceBook.own_company.name
          },
          {
            label: 'Termék számlázandó',
            value: this.invoiceBook.is_product_billable ? 'Igen' : 'Nem'
          },
          {
            label: 'Szolgáltatás számlázandó',
            value: this.invoiceBook.is_service_billable ? 'Igen' : 'Nem'
          },
          {
            label: 'Régió',
            value: this.invoiceBook.region === 'abroad' ? 'Külföldi' : 'Belföldi',
          },
          {
            label: 'Kp. megjegyzés',
            value: this.invoiceBook.cash_comment || ''
          },
          {
            label: 'Ut. megjegyzés',
            value: this.invoiceBook.transfer_comment || ''
          },
          {
            label: 'Létrehozva',
            value: this.$options.filters.dateTime(this.invoiceBook.created_at)
          },
          {
            label: 'Módosítva',
            value: this.$options.filters.dateTime(this.invoiceBook.updated_at)
          },
        ];
        this.loading = false;
      },
      async deleteInvoiceBook() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('invoiceBook/delete', this.invoiceBook.id);
          this.$store.dispatch('invoiceBook/fetchAll');
          this.$router.replace('/sales/invoice-books');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
    },
  };
</script>
